import type { addressQuerySchema } from "@spare-cart/contracts/checkout";
import type { z } from "@spare-cart/contracts/common";

export const addressKeys = {
  all: ["addresses"] as const,
  lists: () => [...addressKeys.all, "list"] as const,
  list: (query: z.input<typeof addressQuerySchema>) => [...addressKeys.lists(), query] as const,
};
